module.exports = __webpack_public_path__ + "static/media/review-icon.50682714.svg";